import React, { useEffect, useState } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "./firebase";

function formatMuralDate(mural) {
  // Old docs: completedAt is a number (Date.now())
  if (mural.completedAt) {
    const d = new Date(mural.completedAt);
    return d.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  // If you later add createdAt (Firestore Timestamp) you can fall back to it
  if (mural.createdAt && typeof mural.createdAt.toDate === "function") {
    const d = mural.createdAt.toDate();
    return d.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  return "Unknown date";
}

function GalleryPage() {
  const [murals, setMurals] = useState([]);

  useEffect(() => {
    // ✅ Keep using completedAt so OLD docs still show
    const q = query(collection(db, "gallery"), orderBy("completedAt", "desc"));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMurals(data);
    });

    return unsubscribe;
  }, []);

  return (
    <div style={{ padding: "10px" }}>
      <h2>🖼️ Completed Murals Gallery</h2>
      {murals.length === 0 && <p>No murals yet!</p>}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
        }}
      >
        {murals.map((mural) => (
          <div key={mural.id} style={{ textAlign: "center" }}>
            <p
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                margin: "0",
                marginBottom: "2px",
              }}
            >
              {mural.answer}
            </p>

            <p
              style={{
                fontSize: "12px",
                color: "gray",
                marginTop: "4px",
                marginBottom: "8px",
              }}
            >
              Clue: {mural.clue}
            </p>

            <img
              // 👇 New docs: displayUrl; old docs: imageUrl
              src={mural.displayUrl || mural.imageUrl}
              alt={mural.answer || "Mural"}
              style={{ width: "100%", height: "auto", display: "block" }}
              onContextMenu={(e) => e.preventDefault()} // ❌ disable right-click
              draggable={false} // 🚫 can't easily drag to desktop
            />

            <p
              style={{
                fontSize: "12px",
                marginTop: "0px",
                marginBottom: "6px",
              }}
            >
              <strong>Artists:</strong>{" "}
              {mural.artists && mural.artists.length
                ? mural.artists
                    .map((a) => `${a.username} (${a.count})`)
                    .join(", ")
                : "Unknown"}
            </p>

            {/* Date mural was saved */}
            <p
              style={{
                fontSize: "12px",
                color: "gray",
                marginTop: "0px",
              }}
            >
              Completed on: {formatMuralDate(mural)}
            </p>
          </div>
        ))}
      </div>

      {/* ===== Footer ===== */}
      <footer style={{ marginTop: "40px", textAlign: "center" }}>
        <a
          href="https://www.instagram.com/muralpatch?igsh=bnhrdTkwMjI5dmhy&utm_source=qr"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "2px",
            textDecoration: "none",
            color: "#4B5563",
            fontSize: "10px",
          }}
        >
          <span>Instagram:</span>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/community-squares-766d6.firebasestorage.app/o/footer%2F46C9DCB8-6230-4B21-8F24-001B0F4C3CA9.PNG?alt=media&token=aade42b3-a937-4cf2-adf1-09fb926fdb36"
            alt="Instagram"
            style={{ width: "50px", height: "50px" }}
          />
        </a>
      </footer>
    </div>
  );
}

export default GalleryPage;
